<template>
    <div>
        <section class="payment-methods-table">
            <div class="row heading-row align-items-center text-center no-gutters" :class="'row-cols-' + numberOfCols">
                <div class="col">
                    <div class="p-2 p-sm-3">
                        <span>Payment Method</span>
                    </div>
                </div>
                <div class="col">
                    <div class="p-2 p-sm-3">
                        <span>Name</span>
                    </div>
                </div>
                <div class="col">
                    <div class="p-2 p-sm-3">
                        <span>Deposit Amount</span>
                    </div>
                </div>
                <div class="col" v-if="fullWidthTable">
                    <div class="p-2 p-sm-3">
                        <span>Withdrawal Amount</span>
                    </div>
                </div>

                <div class="col" v-if="fullWidthTable">
                    <div class="p-2 p-sm-3">
                        <span>Withdraw Time</span>
                    </div>
                </div>
            </div>
            <div v-if="paymentMethods.length > 0">
                <div 
                    :class="'row-cols-' + numberOfCols" 
                    class="row data-row text-center no-gutters p-2 p-sm-3" 
                    v-for="payment in paymentMethods"
                >
                    <div class="col">
                        <div>
                            <div>
                                <img
                                    :data-src="payment.logo"
                                    :title="payment.brand_feature_key.feature"
                                    :alt="payment.brand_feature_key.feature"
                                    class="img-fluid lazyload"
                                >
                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <div>
                            <div>
                                <span>
                                    {{ payment.brand_feature_key.feature }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <div>
                            <div>
                                <span v-if="payment.deposit_amount">
                                    ${{ payment.deposit_amount }}
                                </span>
                                <span v-else>
                                    -
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="col" v-if="fullWidthTable">
                        <div>
                            <div>
                                <span v-if="payment.withdrawal_amount">
                                    {{ payment.withdrawal_amount }}
                                </span>
                                <span v-else>
                                    -
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="col" v-if="fullWidthTable">
                        <div>
                            <div>
                                <span v-if="payment.withdraw_time">
                                    {{ payment.withdraw_time }}
                                </span>
                                <span v-else>
                                    -
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center p-3" v-else>No payments method for the selected state.</div>
        </section>
    </div>

</template>

<script>
    export default {
        name: 'payment-methods-table',
        props: {
            brandFeatures: {
                type: Array,
                require: true
            },
            numberOfCols: {
                type: Number,
                default: 5
            },
            state: {
                type: String,
                require: true
            }
        },
        data: function () {
            return {
                paymentIds: [],
                paymentMethods: [],
                brandFeatureData: [],
                fullWidthTable: false
            }
        },
        mounted: function () {
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.paymentIds = [];
                this.paymentMethods = [];
                this.fullWidthTable = this.numberOfCols === 5 ? true : false;
                this.brandFeatures.filter(payment => {
                    if (payment.us_state.code == this.state && !this.paymentIds.includes(payment.id) ) {
                        this.paymentIds.push(payment.id);
                        this.paymentMethods.push(payment);
                    }
                });
            }
        },
        watch: {
            state() {
                this.fetchData();
            }
        },
    }
</script>